import { render, staticRenderFns } from "./PermissionsUpdateBtn.vue?vue&type=template&id=621cc3e3&lang=pug"
import script from "./PermissionsUpdateBtn.vue?vue&type=script&lang=js"
export * from "./PermissionsUpdateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports